import { Head, Link, router, useForm } from "@inertiajs/react";
import {
  checkout_path,
  line_item_path,
  one_step_checkout_path,
  product_path,
} from "@/routes.js";
import formatMoney from "~/utils/formatMoney.js";
import pageTitle from "~/utils/pageTitle.js";
import { Button } from "~/components/ui/button.jsx";
import { Label } from "~/components/ui/label.jsx";
import { Input } from "~/components/ui/input.jsx";
import { Checkbox } from "~/components/ui/checkbox.jsx";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "~/components/ui/card.jsx";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "~/components/ui/collapsible.jsx";
import { ChevronsUpDown } from "lucide-react";
import { ScrollArea } from "~/components/ui/scroll-area.jsx";
import { Heading } from "@/components/ui/heading.jsx";
import PersonalDataProcessing from "../../components/PersonalDataProcessing";
import { useState } from "react";

const propertiesBlackList = [
  "Минимальное количество",
  "Праздник1",
  "Скидка не распостраняется",
];
export default function Edit({ order, shipping_rates }) {
  const { token, line_items } = order;

  const [accepted, setAccepted] = useState(false);

  const address = {
    country_id: 184,
    country: "Russia",
    city: "Krasnoyarsk",
    zipcode: "660032",
    stateName: "Krasnoyarsk",
    countryIso: "RU",
    address1: "Unknown",
    firstname: "Unknown",
    lastname: "Unknown",
    phone: "+0 000 000 00 00",
  };

  const { data, setData, transform, post, processing, progress, errors } =
    useForm({
      order: {
        email: "",
        comment: "",
        ship_address_attributes: address,
        bill_address_attributes: address,
        payments_attributes: [{ payment_method_id: 3 }],
        shipment_attributes: shipping_rates.map((shipment) => ({
          id: shipment.id,
          selected_shipping_rate_id: shipping_rates[0].id,
        })),
      },
    });

  const handleSubmit = (e) => {
    e.preventDefault();
    post(one_step_checkout_path());
  };

  return (
    <div>
      <Head title={pageTitle("Оформить заказ")} />
      <div className="container mx-auto py-16">
        <div className="flex flex-wrap space-y-8">
          <div className="w-full xl:w-1/2 xl:pr-16 space-y-8 px-4 xl:px-0 order-2 xl:order-1">
            {errors?.base && (
              <div
                className="border-red-600 border text-red-600 p-2 my-2"
                dangerouslySetInnerHTML={{ __html: errors.base }}
              ></div>
            )}
            <div>
              <Heading>Контактные данные</Heading>
            </div>
            <Card>
              <CardContent>
                <form className="py-4" onSubmit={handleSubmit}>
                  <div className="space-y-8 ">
                    <div className="grid gap-3">
                      <Label htmlFor="order-name">Имя</Label>
                      <Input
                        id="order-name"
                        type="text"
                        value={data.order.name}
                        placeholder="Имя"
                        size="xl"
                        onChange={(e) => setData("order.name", e.target.value)}
                      />
                    </div>

                    <div className="grid gap-3">
                      <Label htmlFor="order-email">Электронная почта</Label>
                      <Input
                        id="order-email"
                        type="text"
                        value={data.order.email}
                        placeholder="Электронная почта"
                        size="xl"
                        onChange={(e) => setData("order.email", e.target.value)}
                      />
                    </div>

                    {/*<label>*/}
                    {/*  <CustomInput*/}
                    {/*    type="text"*/}
                    {/*    className="w-full"*/}
                    {/*    value={data.order.email}*/}
                    {/*    placeholder="Электронная почта"*/}
                    {/*    onChange={(e) => setData('order.email', e.target.value)}*/}
                    {/*  />*/}
                    {/*</label>*/}
                    <div className="grid gap-3">
                      <Label htmlFor="order-phone">Телефон</Label>
                      <Input
                        id="order-phone"
                        type="text"
                        size="xl"
                        className="w-full"
                        value={data.order.ship_address_attributes.phone}
                        placeholder="Телефон"
                        onChange={(e) =>
                          setData(
                            "order.ship_address_attributes.phone",
                            e.target.value
                          )
                        }
                      />
                    </div>

                    <div className="flex flex-col space-x-4 items-start xl:items-center space-y-4">
                      <Button
                        size="xl"
                        color={"pink"}
                        className="uppercase font-bold w-full xl:w-auto"
                        disabled={!accepted}
                      >
                        Оформить заказ
                      </Button>
                      <PersonalDataProcessing onChange={setAccepted} />
                      
                    </div>
                  </div>
                </form>
              </CardContent>
            </Card>
          </div>

          <div className="w-full xl:w-1/2 px-8 space-y-8 order-1 xl:order-2">
            <Heading>Ваш заказ</Heading>
            <dl className="space-y-2">
              <div className="flex items-center space-x-2">
                <dt className="text-sm text-gray-500">Номер:</dt>
                <dd>{order.number}</dd>
              </div>

              <div className="flex items-center space-x-2">
                <dt className="text-sm text-gray-500">Сумма:</dt>
                <dd>{formatMoney(order.total)}</dd>
              </div>
            </dl>
            <ul className="space-y-4 divide-y divide-gray-100">
              {line_items.map((li) => {
                const { quantity, product, variant, price, pre_tax_amount } =
                  li;
                const { total_on_hand, product_properties, name } = product;
                const image = product.thumbnail;

                return (
                  <li className="flex items-center gap-4 pb-8">
                    <Link href={product_path(product.slug)}>
                      <img
                        src={image.url}
                        loading="lazy"
                        className="size-20 rounded"
                      />
                    </Link>

                    <div>
                      <h3 className="text-gray-900">
                        <Link href={product_path(product.slug)}>{name}</Link>
                      </h3>

                      <dl className="mt-0.5 space-y-px text-[10px] text-gray-600">
                        {product_properties
                          .filter(
                            (pp) =>
                              !propertiesBlackList.includes(
                                pp.property_presentation
                              )
                          )
                          .map((pp) => (
                            <div className=" space-x-1">
                              <dt className="inline">
                                {pp.property_presentation}:
                              </dt>
                              <dd className="inline">{pp.value}</dd>
                            </div>
                          ))}
                      </dl>
                    </div>

                    <div className="flex flex-1 items-center justify-end gap-2">
                      <div className="">
                        <span className="text-gray-600 text-xs">
                          {formatMoney(price)} &times; {quantity}
                        </span>
                        <br />
                        {formatMoney(pre_tax_amount)}
                      </div>

                      <div className="flex space-x-2 hidden">
                        <button
                          disabled={quantity <= 1}
                          onClick={() =>
                            router.patch(line_item_path(li.id), {
                              quantity: li.quantity - 1,
                            })
                          }
                        >
                          -
                        </button>
                        <button
                          disabled={quantity >= total_on_hand}
                          onClick={() =>
                            router.patch(line_item_path(li.id), {
                              quantity: li.quantity + 1,
                            })
                          }
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
